import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */

// Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/ConfluenceResultMeta.tsx

import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N300 } from '@atlaskit/theme/colors';
import Breadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import { SpacerWrapper, capitalizeFirstLetter } from './quick-find-meta';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var ConfluenceResultMetaWrapper = styled.span({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var BreadcrumbsWrapper = styled.div({
  'nav > ol': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'li:not(:last-child)::after': {
      padding: "0px ".concat("var(--ds-space-050, 4px)"),
      width: '4px',
      color: "var(--ds-text-subtle, ".concat(N300, ")")
    },
    li: {
      height: '14px',
      lineHeight: '14px'
    },
    span: {
      color: "var(--ds-text-subtle, ".concat(N300, ")")
    },
    flexWrap: 'nowrap',
    'li a': {
      alignItems: 'center',
      pointerEvents: 'none',
      maxWidth: '200px',
      fontSize: '11px',
      lineHeight: '14px',
      padding: '0px'
    },
    'li button': {
      pointerEvents: 'none',
      fontSize: '11px',
      lineHeight: '14px'
    }
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var ConfluenceTypeWrapper = styled.span({
  color: "var(--ds-text-subtle, ".concat(N300, ")")
});
export var ConfluenceResultMeta = function ConfluenceResultMeta(_ref) {
  var resultContentType = _ref.resultContentType,
    resultAncestors = _ref.resultAncestors,
    resultSpace = _ref.resultSpace;
  var breadcrumbs = getBreadcrumbs(resultAncestors, resultSpace);
  return /*#__PURE__*/React.createElement(ConfluenceResultMetaWrapper, null, /*#__PURE__*/React.createElement(ConfluenceTypeWrapper, null, "Confluence"), /*#__PURE__*/React.createElement(SpacerWrapper, null, "\u2022"), /*#__PURE__*/React.createElement(ConfluenceTypeWrapper, null, "".concat(capitalizeFirstLetter(resultContentType))), (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SpacerWrapper, null, "\u2022"), /*#__PURE__*/React.createElement(BreadcrumbsWrapper, null, /*#__PURE__*/React.createElement(Breadcrumbs, {
    maxItems: 2,
    isExpanded: false,
    onExpand: function onExpand(e) {
      return e.preventDefault();
    }
  }, breadcrumbs.map(function (_ref2, itemIndex) {
    var id = _ref2.id,
      title = _ref2.title;
    return /*#__PURE__*/React.createElement(BreadcrumbsItem, {
      key: id,
      text: title || '',
      truncationWidth: itemIndex === breadcrumbs.length - 1 || itemIndex === 0 ? 130 : 50
    });
  })))));
};
export var getBreadcrumbs = function getBreadcrumbs(ancestors, space) {
  var breadcrumbs = [];
  if (space) {
    var spaceBreadcrumb = {
      id: space === null || space === void 0 ? void 0 : space.id,
      title: space === null || space === void 0 ? void 0 : space.name
    };
    if (!ancestors || ancestors.length === 0) {
      breadcrumbs = [spaceBreadcrumb];
    } else if (ancestors.length >= 1) {
      breadcrumbs = [spaceBreadcrumb].concat(_toConsumableArray(ancestors.slice(1)));
    }
  }
  return breadcrumbs;
};